<template>
  <scout-form
    :is-modified="!!value.minimum || !!value.maximum"
    label="年齢"
    half
  >
    <select
      v-model="value.minimum"
      :class="{ 'is-invalid-input': isInvalid }"
      class="boss-input-select"
      data-test="select-age-gte"
    >
      <option
        v-for="(age, i) in ageOptions"
        :key="i"
        :value="age"
      >
        {{ age }}
      </option>
    </select>
    <span>歳</span>
    〜
    <select
      v-model="value.maximum"
      :class="{ 'is-invalid-input': isInvalid }"
      class="boss-input-select"
      data-test="select-age-lte"
    >
      <option
        v-for="(age, i) in ageOptions"
        :key="i"
        :value="age"
      >
        {{ age }}
      </option>
    </select>
    <span>歳</span>
    <span
      v-if="isInvalid"
      class="form-error is-visible margin-0"
      data-test="validation"
    >正しい大小関係で範囲を入力してください。</span>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import * as definition from '@/lib/labelValueMappings'

export default {
  components: {
    ScoutForm
  },
  props: {
    value: {
      type: Object,
      required: true,
      validator (val) {
        return Object.prototype.hasOwnProperty.call(val, 'minimum') && Object.prototype.hasOwnProperty.call(val, 'maximum')
      }
    }
  },
  data () {
    return {
      ageOptions: definition.age
    }
  },
  computed: {
    isInvalid () {
      return this.value.minimum > this.value.maximum
    }
  }
}
</script>
